module.exports = "/cyber/_next/static/images/PubgTooltipMobile-23e66a29a296d2f539d92771e6edfc11.jpg";